import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProductReleaseService } from '../../services/ProductReleaseService';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';
import { PageLayoutViewChangeLogComponent } from '../changelog/changelog.component';
import { MdDialog, MdDialogRef } from '@angular/material';
import { AzureDownloadService } from './AzureDownloadService.service';

@Component({
    selector: 'my-page-download',
    template: require('./DownloadSCAL360.component.html')
})

export class PageDownloadSCAL360Component {
    ChangeLog: any;
    validationForm: FormGroup;
    OTPForm: FormGroup;
    errorMessage: string;
    successMessage: string;
    disabled = true;
    IPAddress: any;

    IsDisabled: boolean;
    IsMailSend: boolean = false;

    submitted: boolean = false;
    StableRelease: string;
    constructor(private formBuilder: FormBuilder,
        public dialog: MdDialog,
        private productReleaseService: ProductReleaseService,
        private http: HttpClient,
        private appLoaderService: AppLoaderService,
        private fileService: AzureDownloadService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.buildForm();
        this.getIPAddress();
    }

    buildForm() {
        this.validationForm = this.formBuilder.group({
            contactno: [{ value: '', disabled: false }],
            licenseKey: [{ value: '', disabled: false }, Validators.required],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
        });

        this.OTPForm = this.formBuilder.group({
            OTP: [{ value: '', disabled: false }, Validators.required]
        });
    }

    validateInfo() {
        this.errorMessage = '';
        if (this.validationForm.invalid) {
            return;
        }

        // First Send Email
        let LicenseInfo = {
            EmailId: this.validationForm.value.email,
            LicenseKey: this.validationForm.value.licenseKey,
            PhoneNo: this.validationForm.value.contactno,
            IPAddress: this.IPAddress
        };

        this.appLoaderService.open("Loading");
        this.productReleaseService.SendEmailToSCAL3609Customer(LicenseInfo).subscribe((result: any) => {

            if (result.DataObject != null) {
                this.IsMailSend = true;
                this.submitted = true;
                this.isDisabled(true, 'licenseKey');
                this.isDisabled(true, 'contactno');
                this.isDisabled(true, 'email');
                this.cdr.detectChanges();
                this.appLoaderService.close();
            }
            else {
                this.appLoaderService.close();
                this.errorMessage = result.Error;
                this.validationForm.patchValue({
                    licenseKey: ''
                });
                this.cdr.detectChanges();
            }
        },
            _error => {
                this.appLoaderService.close();
            });
    }

    OTPVerfication() {
        this.errorMessage = "";
        this.appLoaderService.open("Verify OTP");
        let LicenseInfo = {
            EmailId: this.validationForm.value.email,
            LicenseKey: this.validationForm.value.licenseKey,
            PhoneNo: this.validationForm.value.contactno,
            IPAddress: this.IPAddress,
            OTP: this.OTPForm.value.OTP,
            SoftwareVersionNo: this.StableRelease
        };
        this.productReleaseService.VerifySCAL360OTPVerification(LicenseInfo).subscribe((result: any) => {
            if (result.DataObject != null) {
                this.startDownload(result.DataObject[0].FilePath, LicenseInfo);
            }
            else {
                this.OTPForm.patchValue({
                    OTP: ''
                });
                this.errorMessage = result.Error;
                this.appLoaderService.close();
            }
        },
            _error => {
                this.appLoaderService.close();
            });
    }

    getIPAddress() {
        this.appLoaderService.open();
        this.productReleaseService.getIPAddress().subscribe((result: any) => {
            this.IPAddress = result.ip;
            this.getStableRelease();
        },
            _error => {
                this.appLoaderService.close();
            });
    }

    getStableRelease() {
        this.productReleaseService.getStableRelease(14).subscribe((result: any) => {
            if (result.DataObject != null) {

                this.StableRelease = result.DataObject.SoftwareVersionNo;
                this.ChangeLog = result.DataObject.ChangeLog;
                this.cdr.detectChanges(); // Force re-rendering                
            }
            this.appLoaderService.close();

        },
            _error => {
                this.appLoaderService.close();
            });
    }

    isDisabled(value: boolean, controlname: string) {
        this.IsDisabled = value;
        if (value) {
            this.validationForm.controls[controlname].disable();
        } else {
            this.validationForm.controls[controlname].enable();
        }
    }

    viewChangeLog() {
        setTimeout(() => {
            let confirmdialog: MdDialogRef<PageLayoutViewChangeLogComponent> = this.dialog.open(PageLayoutViewChangeLogComponent, { height: "50%", data: { "ChangeLog": this.ChangeLog }, disableClose: true });
            confirmdialog.afterClosed().subscribe(result => {
                console.log(result);
            });
        }, 0);
    }

    startDownload(filePath, LicenseInfo) {
        this.productReleaseService.getSASToken(filePath).subscribe(
            response => {
                this.fileService.downloadFile(response.url, (percentage) => {
                    this.appLoaderService.ChangeLoaderTitle("Downloading File");
                    this.appLoaderService.ChangePercentage(percentage.toFixed(0) + '%');
                    console.log("Percentage:" + percentage.toFixed(0) + "@" + percentage);
                    if (percentage >= 100) {
                        console.log("Closing loader...");
                        this.IsMailSend = false;
                        this.validationForm.patchValue({
                            licenseKey: '',
                            contactno: '',
                            email: ''
                        });
                        this.OTPForm.patchValue({
                            OTP: ''
                        });
                        this.successMessage = "Successfully Downloaded SCAL-360 File";
                        // Call DownloadDetails after successful download
                        this.addSoftwareDownloadDetails(LicenseInfo);
                    }
                });
            },
            _error => {
                this.appLoaderService.close();
            });

    }
    addSoftwareDownloadDetails(LicenseInfo) {
        this.productReleaseService.AddSoftwareDownloadDetails(LicenseInfo).subscribe((result) => {
            this.appLoaderService.close();
        })
    }

}













// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/extra-pages/DownloadSCAL360/DownloadSCAL360.component.ts